import {Component, OnInit} from '@angular/core';
import {InputTextareaModule} from "primeng/inputtextarea";
import {TemplateComponent} from "../template/template.component";
import {Contact} from "../../dto/Contact";
import {FormsModule} from "@angular/forms";
import {NumberTextPipe} from "../../pips/number-text.pipe";

@Component({
  selector: 'app-contact-us-page',
  standalone: true,
    imports: [
        InputTextareaModule,
        FormsModule,
        NumberTextPipe
    ],
  templateUrl: './contact-us-page.component.html',
  styleUrl: './contact-us-page.component.css'
})
export class ContactUsPageComponent  extends TemplateComponent implements OnInit{
  contact:Contact=new Contact();
  contactSetting:any;
  ngOnInit() {
          this.titleService.setTitle($localize`:@@Contact Us:Contact Us`)
      document.body.scrollTop = 0;
      this.contactSetting = JSON.parse(this.global.getMainData()['contact_us']['data']);
      setTimeout(() => {
          this.contactSetting = JSON.parse(this.global.getMainData()['contact_us']['data']);
      }, 500)
      this.meta.addTag({name:'keywords',content:"contact us"},true);


  }

  addContact() {
    let params = {};
    let body = this.contact;
    this.global.progressBar = true;
    var observable = this.restBack.doPost("lnd/site/add_contact", body, params);
    observable.then((res: string) => {
          if (res["status"] == 200) {
            let o = res["entity"];
            // this.loadIndexData(null);
            this.messageService.clear();
            this.messageService.add({
              severity: 'info',
              summary: $localize`:@@send Message:send Message`,
              detail: $localize`:@@The message was sent:The message was sent`
            });
            this.contact =  new Contact();

          } else if (res["status"] == 400) {

          } else if (res["status"] == 401) {

              if (res["message"] == "rate_limited") {

                  this.messageService.clear();
                  this.messageService.add({
                      severity: 'error',
                      summary: $localize`:@@Error:Error`,
                      detail: $localize`:@@rate_limited_msg:rate_limited_msg`,
                      life: 6000
                  });
              }
          }
          return res;
        },
        error => {
          this.messageService.clear();
          this.messageService.add({
                severity: 'error',
                summary: $localize`:@@Error:Error`,
                detail: $localize`:@@Server Timout Det:Server Timout Det`
              }
          );
        }).finally(() => {
      this.global.progressBar = false;


    });
  }
}
